import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListagemMoradoresComRendaPage } from './listagem-moradores-com-renda.page';

const routes: Routes = [{ path: '', component: ListagemMoradoresComRendaPage }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ListagemMoradoresComRendaPageRoutingModule { }
